// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3FDWl","content":"Consent_content__3Hkb0","footer":"Consent_footer__ZuDYO"};